import { render, staticRenderFns } from "./PiecesDrawer.vue?vue&type=template&id=5bac3f36&"
import script from "./PiecesDrawer.vue?vue&type=script&lang=js&"
export * from "./PiecesDrawer.vue?vue&type=script&lang=js&"
import style0 from "./PiecesDrawer.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports